import React from "react";
import { ProducerReportLayoutTemplate } from "themes/common/components/producer";

function ProducerReportLayout(props) {
    return <ProducerReportLayoutTemplate {...props} />;
}

export default ProducerReportLayout;
